import { render, staticRenderFns } from "./AccountModalRegisterBtn.vue?vue&type=template&id=5f84dea1&"
import script from "./AccountModalRegisterBtn.vue?vue&type=script&lang=js&"
export * from "./AccountModalRegisterBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports